import { Component, OnInit, Inject, Optional } from '@angular/core';
import {Requests} from 'src/app/_model/Requests';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { WfApproveRequest } from 'src/app/_model/request/WfApproveRequest';
import { User } from 'src/app/_model/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import {RequestService} from "../../_services/request.service";

@Component({
    selector: 'app-requestsRejectSelected',
    templateUrl: './requestsRejectSelected.component.html',
    styleUrls: ['./requestsRejectSelected.component.css'],
    standalone: true,
        imports: [
            MatDialogModule
        ]
})
export class RequestsRejectSelected implements OnInit {
    request:WfApproveRequest=new WfApproveRequest();
    currentUser: User;
    constructor(public dialogRef: MatDialogRef<RequestsRejectSelected>,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: Requests[],
                private authService: AuthenticationService,
                private requestService: RequestService,
                private toastr: ToastrService) {
        this.currentUser = this.authService.currentUserValue;
    }

    ngOnInit() {
    }
    rejectSelected(){

        this.data.forEach(element => {
            this.request.employeeId = this.currentUser.employeeId;
            this.request.operationRecordId=element.id;
            this.request.operationTableName="REQUESTS";
            this.requestService.rejectRequests(this.request).subscribe(result => {
                this.toastr.success('Reddetme işlemi başarılı', '');
                this.dialogRef.close();
            }, error => {
                this.toastr.error(error.error.msg, 'Hata');
                this.dialogRef.close();
            });
        });

    }
}
